import { render, staticRenderFns } from "./TextTile.vue?vue&type=template&id=10785e8c&scoped=true&"
import script from "./TextTile.vue?vue&type=script&lang=js&"
export * from "./TextTile.vue?vue&type=script&lang=js&"
import style0 from "./TextTile.vue?vue&type=style&index=0&id=10785e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10785e8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
